export default {
  tip: '提示',
  title: '后台管理系统',
  logoutTip: '退出系统, 是否继续?',
  submitText: '确定',
  cancelText: '取消',
  search: '请输入搜索内容',
  menuTip: '没有发现菜单',
  wel: {


    project: '项目访问',
    count: '项目数',

  },
  route: {
    info: '个人信息',
    website: 'bladex官网',
    avuexwebsite: 'avuex官网',
    dashboard: '首页',
    more: '更多',
    tags: '标签',
    store: '本地存储',
    api: '全局函数',
    logs: '日志监控',
    table: '表格',
    form: '表单',
    top: '返回顶部',
    data: '数据展示',
    permission: '权限',
    error: '异常页面',
    test: '测试页面'
  },
  login: {
    title: '登录 ',
    info:'后台管理系统',
    tenantId: '请输入租户ID',
    username: '请输入账号（手机号）',
    password: '请输入密码',
    forpass:'忘记密码',
    phone: '请输入手机号',
    code: '请输入验证码',
    submit: '登录',
    userLogin: '账号密码登录',
    phoneLogin: '手机号登录',
    thirdLogin: '第三方系统登录',
    msgText: '发送验证码',
    msgSuccess: '秒后重发',
  },
  navbar: {
    logOut: '退出登录',
    userinfo: '个人信息',
    dashboard: '首页',
    lock: '锁屏',
    bug: '没有错误日志',
    bugs: '条错误日志',
    screenfullF: '退出全屏',
    screenfull: '全屏',
    language: '中英文',
    notice: '消息通知',
    theme: '主题',
    color: '换色',
    reset: '重置'
  },
  tagsView: {
    search: '搜索',
    menu: '更多',
    clearCache: '清除缓存',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  // 实时页面
  realtimeinfo:{
    checkDev:"选择项目",
    search:"搜索",
    roomNum:"楼号",
    eleNum:"梯号",
    offLine:'离线',
    onLine:"在线",
    turnOff:"关机",
    powerOn:"开机",
    standard:"标准",
    eleTem:"轿厢温度"

  },
  realdetile:{
    filterAir:"筛选空调",
    eleInfo:'空调信息',
    infoPara:"信息参数",
    faultInfo:"故障信息",
    setPara:"设定参数",
    water:"水位指示",
    view:"查看",
    search:"搜索",
    operaStatus:"运行状态",
    opera:"操作",
    return:"返回",
    serNum:"序号",
    airconditionalNum:"空调台数",
    contUnit:"联系单位",
    projectStatus:"项目状态",
    delayOff:"延迟关机",
    modelDetail:"模式详情",
    choAir:"选择空调",
    pleInputAirCode:"请输入空调编号",
    timeModeView:"定时模式信息查看",
    eleTem:"电梯轿厢温度",
    waterLevel:"水位",
    suVoltage:"电源电压",
    totalCurrent:"总电流",
    coilTemp:"盘管温度",
    windTem:"出风温度",
    heating:"制热",
    refrigeration: "制冷",
    wind:'送风',
    setwindSpeed:"设定风速",
    highWind:"高风",
    lowWind:"低风",
    on:"开",
    off:"关机",
    defrosting:"化霜",
    highWindStatus:"高风继电器状态",
    lowWindStatus:"低风继电器状态",
    waterPumpStatus:"水泵继电器状态",
    heatStatus:"加热继电器状态",
    paStatus:"压缩继电器状态",
    eleTemFail:"电梯轿厢温度传感器故障",
    windTemFail:"出风温度传感器故障",
    coilTemFail:"盘管温度传感器故障",
    airCho:"空调筛选",
   },
  //远程操作
  manipulation:{
    questTimedOut:"请求超时,请重新操作",
    executing:"指令执行中",
    sglOpera:"单台操作",
    bulkOpera:"批量操作",
    select:"选择项目",
    devName:"项目名称",
    buildNum:"楼号",
    ladderNum:"梯号",
    airModel:"空调型号",
    installAddress:"安装地址",
    executionResult:"指令执行结果",
    airModelSetting:"空调运行模式设置",
    airParameterSetting:"空调参数设置",
    manual:"手动",
    timing:"定时",
    unreported:"未上报",
    sleepModeOff:"休眠模式关",
    sleepModeOn:"休眠模式开",
    sleepMode:"休眠模式",
    manModeParSetting:"手动模式参数设定",
    timModeParSetting:"定时模式参数设定",
    manMode:"手动模式",
    timMode:"定时模式",
    ParSetting:"参数设定",
    choice:"所选空调",
    benTimeSetting:"基准时间设定",
    curHour:"当前时分",
    currentWeek:"当前星期",
    timingSetting:"定时时间设置",
    addTime:"增加定时器",
    timer:"定时器",
    timedOn:"定时开",
    timedOff:"定时关",
    model:"模式",
    temp:"温度",
    windSpeed:"风速",
    week:"星期",
    cancel:"取消",
    sure:"确定",
    airNum:"空调编号",
    elevatorBrand:"电梯品牌",
    deviceAdressNum:"设备地址码",
    comBoard:"通信板IMEI码",
    comStatus:"通信状态",
    workStatus:"工作状态",
    operaMode:"运行模式",
    opeSec:"指令执行成功",
    opefau:"指令执行失败",

    pleChoiceAir:"请先选择空调",
    opeSucc:"操作成功",
    exDifAir:"存在与当前设定模式不同的空调",
    sawBack:"锯背压力报警历史",
    insNum:"安装台数",
    auto:"自动",
    wind:"通风",
    paSelect:"参数选择",
    temRange:"温度范围",
    devStatus:"设备状态",
    anyTime:"任意时间点",
    timeSet:"定时时间设定"

  },
  //历史数据
  dataAnalysis:{
    deviceInfo:"设备信息",
    timeChs:"时间选择",
    monitorchs:"监控点选择",
    inquire:"查询",
    reset:"重置",
    chart:"图表",
    form:"表格",
    time:"时间",
    prev:"上一页",
    next:"下一页",

    project:"项目",
    lift:"电梯",
    endTime:"结束时间",
    startTime:"开始时间",
    pleCho:"请选择",
    unit:"单位",
    alFirstPage:"已经是第一页",
    alLastPage:"已经是最后一页",
    none:"暂无",
  },
  //操作日志
  sendCmdLog:{
    queryMethod:"查询方式",
    date:"日期",
    actContent:"操作内容",
    actResult:"操作结果",
    actPeople:"操作人",
    pleAddCode:"请输入地址码",
    arrive:"-",
    startDate:"开始时间",
    endDate:"结束时间",
    addCodeQuery:"按地址码查询",
    levelQuery:"按层级查询",
    today:"当天",
    lastWeek:"最近一周",
    lastMonth:"最近一个月",
    success:"成功",
    fault:"失败",
  },
  //报警设置
  alarmSetting:{
    airModelQuire:"空调型号查询",
    addAlarm:"新增报警",
    alarmName:"报警名称",
    alarmLevel:"报警等级",
    assMonitor:"关联监控点",
    alarmContent:"报警内容",
    triggerCondition:"触发条件",
    alarmType:"报警类型",
    alarmThreshold:"报警阈值",
    copMethodChoose:"应对方法(可选)",
    webAlarm:"web系统告警",
    alarmContacts:"报警联系人",
    assVariable:"关联变量",
    alarm:"报警",
    delete:"删除",
    edit:"编辑",
    prompt:"提示",
    promptContent:"确定要删除吗",

    inputAlarmName:"请输入报警名称",
    choAlarmType:"请选择报警类型",
    choAssVariable:"请选择关联变量",
    inputAlarmValue:"请输入报警值",
    inputAlarmContent:"请输入报警内容",
    editAlarm:"编辑报警",
    addSuc:"添加成功",
    addFauRepeat:"添加失败,请稍后重试",
    chaSuc:"修改成功",
    chaFauRepeat:"修改失败,请稍后重试",
    fillComplete:"请填写完整",
    deleteSuc:"删除成功",
    deleteFau:"删除失败",
    airCode:"空调编码",
    statusList:"状态列表",
    number:"数量",
  },
  //报警数据
  alarmData:{
    monitorList:"监控点列表",
    dataName:"数据点名称",
    curAlarmTime:"当前报警时间",
    dataValue:"数据值",
    status:"状态",
    processTime:"处理时间",
    copMethod:"应对方法",

    processed:"已处理",
    notProcessed:"未处理",
    lookHistory:"点击查看历史报警",
    choiceDate:"选择日期",
    startDate:"开始日期",
    endDate:"结束日期",
    fail:"故障",
    numericValue:"数值",
    everyPage:"每页",
    strip:"条",
    currentPage:"当前页",
    loading:"正在加载",
  },
  //人员管理
  userManage:{
    account:"账号(手机号)",
    operatorName:"操作人员名称",
    operaPermission:"操作权限",
    addUser:"新增用户",
    userName:"用户名称",
    password:"密码",
    phoneNum:"手机号",
    roleName:"角色名称",

    pleInputProName:"请输入项目名称",
    newAdd:"新增",
    assignItem:"分配项目",
    ifActivation:"是否激活",
    addAccountName:"请添加用户名称",
    addPassword:"请添加密码",
    addPhone:"请添加手机号",
    addRole:"请分配角色",
    phoneFault:"手机号格式错误",
    chaAccount:"修改用户",
    passLess:"密码长度最少为6位",
    revisePer:"修改权限",
    addRoleName:"请添加角色名称",
    addRoleDes:"请添加角色描述",
    addUpRole:"请添加上级角色",
    addUpRole:"新增角色",
    reviseRole:"修改角色",
  },
  roleManage:{
    roleDescription:"角色描述",
    createTime:"创建时间",
    parentRole:"上级角色",
    revise:"修改",

    updateSuc:"更新成功",
    upDateFauRepeat:"更新失败,请重试"

  },

  fileManage:{
    areaName:"区域名称",
    add:"添加",
    timeSetting:"安装时间",
    province:"省份",
    city:"城市",
    longitude:"经度",
    latitude:"纬度",
    contact:"联系人",
    contactPhone:"联系电话",
    installer:"安装人员",
    map:"地图上选点",
    keyWords:"关键词搜索",
    infoback:"确定删除",

    pleChoArea:"请选择区域",
    lookHisRevise:"查看历史修改",
    viewDetail:"查看详情",
    handoff:"切换",
    insHisNameRevise:"安装工地历史名称修改",
    chaAccount:"更改账户",
    updateTime:"更新时间",
    debug:"调试",
    set:"运行",
    inputLongitude:"请输入经度",
    inputLatitude:"请输入纬度",
    inputCityName:"请输入城市名",
    inputProvinceName:"请输入省份名",

  },

  omcenter:{
    name:"名称",
    address:"地址",
    onlineDev:"在线设备",
    offlineDev:"离线设备",
    devNum:"设备总数",
    hideDevName:"隐藏设备名称",
    piece:"个",
    showDevName:"显示配设备名称",
    hideDevName:"隐藏配设备名称",
    inChina:"中国",
    devPlace:"设备分布情况"
  },

  parmodel:{
    theMonday:"星期一",
    theTuesday:"星期二",
    theWednesday:"星期三",
    theThursday:"星期四",
    theFriday:"星期五",
    theSaturday:"星期六",
    theSunday:"星期日",
    temMoreRange:"温度超出范围",
    necTimer:"定时器内容为必选项",
    temRangeIs:"温度范围为",
    noTemEmpty:"温度不能为空",
    pleTemRight:"请检查温度是否输入正确",
    pointIssued:"指令已下发",
    mostAddTenPiece:"最多添加10条",
    leastOnePiece:"最少存在一条",
  },

  stationModal:{
    assignmentDev:"分配设备",
    devCode:"设备编码",
    devModel:"设备型号",
    devBh:'设备编号',
    setSuc:"设置成功",
    all:'全部',
    setFauRepeat:"设置失败,请稍后重试"
  },

  fileInfo:{
    pleInputAirCode:"请输入空调编号",
    totalAirModel:"空调型号统计",
    import:"导入EXCEL",
    clickLoad:"点击导入",
    explain:"说明: 导入文件类型必须为excel格式，你可以先点击",
    downImport:"下载模板",
    boundBoard:"绑定通信板",
    totalAirModel:"空调型号统计",
    hangZhou:"杭州",
    place:"地点",
    pleSearchPlace:"请输入要搜索的地点",
    mapPoint:"地图上选点",
    keySearch:"关键词搜索",


    boundType:'通信板类型',
    devadress:'设备地址',
    pleInputAirlh:'请输入空调楼号',
    pleInputAirth:'请输入空调梯号',
    pleInputAirxh:'请输入空调型号',
    pleInputAirpp:'请输入电梯品牌',
  },
}
